// extracted by mini-css-extract-plugin
export var changeIcon = "_6c-4";
export var container = "_6c-0";
export var divider = "_6c-7";
export var externalLinkIcon = "_6c-1";
export var green = "_6c-5";
export var helpCircleIcon = "_6c-3";
export var iconButton = "_6c-2";
export var red = "_6c-6";